import React from 'react'
import { Box } from '@material-ui/core'

import { OrdersList } from './OrdersList'
import { OpenPalletModal } from '../OpenPalletModal'

export default function OrdersPage() {
  return (
    <Box>
      <OpenPalletModal />

      <OrdersList />
    </Box>
  )
}
